import { ALL_VALUE } from '@/const';
import { Gender, GENDERS, LabelType, availableLabelTypes } from '@/enum';
import { useAccountInfo } from '@/store/account';
import { url } from '@/url';
import React, { FC, ComponentType } from 'react';
import { Redirect } from 'react-router';
import { ClassifyLabeler } from './component/classify';
import { VerifyLabeler } from './component/verify';
import { CommonLabelProps } from './interface';

interface LabelProps {
  gender: Gender;
  c1: string;
  c2: string;
  type: LabelType;
}

const TypeLabelerDict: Record<LabelType, ComponentType<CommonLabelProps>> = {
  [LabelType.Classify]: ClassifyLabeler,
  [LabelType.Verify]: VerifyLabeler,
};

const LabelCore: FC<LabelProps> = props => {
  const Labeler = TypeLabelerDict[props.type];

  return (
    <div>
      <Labeler {...props} />
    </div>
  );
};

export const Label: FC<LabelProps> = props => {
  const { userStatus } = useAccountInfo();

  // 验证参数的合法性
  if (!availableLabelTypes(userStatus).includes(props.type) || !GENDERS.includes(props.gender)) {
    return <Redirect to={url.home()} />;
  }

  return <LabelCore gender={props.gender} c1={props.c1} c2={props.c2 === ALL_VALUE ? undefined : props.c2} type={props.type} />;
};
